// Displays the details of each foodItem on the marketplace.  It's just the section
// of the foodItem that is the item name, the price, the farmName and the description.
import React from "react";
import FarmPopover from "./FarmPopover.jsx";
import ItemDescription from "./ItemDescription.jsx";
import { getIconByKey } from "../../../images/Icons"; // Import the function to get icons
import { getShopperPrice } from "../Functions/FoodGroupingUtils.js";

export default function ItemDetails({ row, userInfo, pickupLocationDetails }) {
  // The price of the foodItem for the distribution location
  const price = row.suggestedPrice ? "0.00" : parseFloat(row.price).toFixed(2);
  // The price of the foodItem for the individual
  const individualPrice = parseFloat(
    price / (row.distributionQuantity / row.individualQuantity),
  ).toFixed(2);
  const userPrice = getShopperPrice(
    row,
    userInfo,
    pickupLocationDetails,
  ).toFixed(2);
  // If the user is a distribution location then we will use the per unit quantity
  // for the distribution locations.  Otherwise we'll use the individual quantity.
  let userPerUnit =
    (userInfo.userType === "individual"
      ? row.individualDescription || row.description
      : row.description) || "";
  // Add the suggested price to the description so the user knows what they should
  // be paying.
  if (row.suggestedPrice) {
    if (userInfo.userType === "individual") {
      userPerUnit = userPerUnit.concat(
        " Suggested Donation of $",
        parseFloat(
          row.price / (row.distributionQuantity / row.individualQuantity),
        ).toFixed(2),
      );
    } else {
      userPerUnit = userPerUnit.concat(
        " Suggested Donation of $",
        parseFloat(row.price).toFixed(2),
      );
    }
  }

  return (
    <div className="Item-Details">
      <>
        {/* The popover launches when a user clicks the farm's name. See comments in FarmPopover component for additional information */}
        <FarmPopover row={row} />
      </>
      <span className="Item-Name-Marketplace">
        {row.item}
        {/* Check if food.tagList exists and has items */}
        {row.tagList && row.tagList.length > 0 && (
          <div style={{ display: "inline-flex", marginLeft: "8px" }}>
            {row.tagList.map((tag) => (
              <span key={tag.key} style={{ marginRight: "4px" }}>
                {getIconByKey(tag.key)} {/* Render the icon for each tag */}
              </span>
            ))}
          </div>
        )}
      </span>
      {parseFloat(row.minimumPurchase) > 1 &&
        (userInfo.userType === "distributionLocation" ||
          userInfo.userType === "admin") && (
          <p className="Minimum-Purchase">Min Qty x {row.minimumPurchase}</p>
        )}
      <div className="Item-Price-Description">
        <div className="Item-Price-Marketplace">
          ${userPrice}
          {row.packageFee > 0 && <>*</>}
        </div>
        /
        <ItemDescription
          description={userPerUnit}
          itemName={row.item}
          label={
            userInfo.userType === "individual"
              ? "Individual description"
              : "Distribution description"
          }
        />
      </div>
      {row.packageFee > 0 && userInfo.userType === "individual" && (
        <p className="Item-Package-Fee">
          *includes package fee ${parseFloat(row.packageFee).toFixed(2)}/per
          item
        </p>
      )}
      {row.packageFee > 0 && userInfo.userType === "distributionLocation" && (
        <p className="Item-Package-Fee">
          * plus package fee ${parseFloat(row.packageFee).toFixed(2)}/per item
        </p>
      )}
      {userInfo.userType === "admin" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p className="Item-Name-Marketplace">Individual&apos;s Info</p>
          <div className="Item-Price-Description">
            <div className="Item-Price-Marketplace">
              ${individualPrice}
              {row.packageFee > 0 && <>*</>}
            </div>
            /
            <ItemDescription
              description={row.individualDescription}
              itemName={row.item}
              label="Individual description"
            />
          </div>
          {row.packageFee > 0 && (
            <p className="Item-Package-Fee">
              *package fee ${parseFloat(row.packageFee).toFixed(2)}/per item
            </p>
          )}
        </div>
      )}
    </div>
  );
}
